import { Paper, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface SettingsBoxProps {
  title: string | ReactNode // Changed the type of title to accept string or ReactNode
  subtitle?: string
  children: ReactNode
  data_testid?: string
}

function SettingsBox({ title, subtitle, children, data_testid }: SettingsBoxProps) {
  return (
    <Paper sx={{ mb: 4, p: 4, borderRadius: 3, border: 1, borderColor: 'grey.300' }} data-testid={data_testid}>
      <Typography variant='h6' className='mb-2 text-gray-800 font-semibold'>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant='subtitle2' className='mb-4 text-gray-600'>
          {subtitle}
        </Typography>
      )}
      {children}
    </Paper>
  )
}

export default SettingsBox
